import { ArrowRightIcon } from "../../shared/Icons";
import { StarIcon } from "../../shared/Icons/StarIcon";
import { notificationsAtom, themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { useNavigate, useParams } from "react-router";
import { twMerge } from "tailwind-merge";

const VoyageNotification = () => {
  const { tcCode, voyageNo } = useParams();
  const notifications = useAtomValue(notificationsAtom) ?? [];

  if (!tcCode || !voyageNo) {
    return null;
  }

  const notification = notifications.find(
    (notif) => String(notif?.TC_CODE ?? "") === tcCode && String(notif?.VOYAGE_NO ?? "") === voyageNo,
  );

  return notification ? <VoyageAssesmentNotification tcCode={tcCode} voyageNo={voyageNo} /> : null;
};

export const VoyageAssesmentNotification = ({ tcCode, voyageNo }: { tcCode?: string; voyageNo?: string }) => {
  const theme = useAtomValue(themeAtom);

  const navigate = useNavigate();
  const ownerRatingsUrl = `/voyage/assessment/${tcCode}/${voyageNo}`;
  const onClick = () => navigate(ownerRatingsUrl);

  return (
    <div
      className={twMerge(
        "flex h-fit w-[432px] items-center justify-between gap-4 rounded-lg border border-[#1F8475] p-6",
        theme.myVesselsTableRow.row.primary,
      )}
    >
      <span className={twMerge("rounded-full p-2", theme.home.tailwind.pageBackground)}>
        <StarIcon fill="#1F8475" />
      </span>
      <div className="flex flex-col gap-1">
        <p className="font-bold">Voyage Assessment</p>
        <p className={twMerge("text-sm", theme.uwhcAssistant.text)}>
          Please complete the voyage assessment for this voyage.
        </p>
      </div>
      <button onClick={onClick}>
        <ArrowRightIcon color="#1F8475" />
      </button>
    </div>
  );
};

export default VoyageNotification;
